export interface BankReplacementTokens {
	bank1: string;
	bank2: string;
	bank3: string;
	bank4: string;
	bank5: string;
}

export const BANK_REPLACEMENT_TOKENS: BankReplacementTokens = {
	bank1: "@[bank1]",
	bank2: "@[bank2]",
	bank3: "@[bank3]",
	bank4: "@[bank4]",
	bank5: "@[bank5]"
}

export interface BucketReplacementTokens {
	bucket1: string;
	bucket2: string;
	bucket3: string;
	bucket4: string;
}

export const BUCKET_REPLACEMENT_TOKENS: BucketReplacementTokens = {
	bucket1: "@[bucket1]",
	bucket2: "@[bucket2]",
	bucket3: "@[bucket3]",
	bucket4: "@[bucket4]"
}